import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  progress: {
    marginTop: "0.5rem",
  },
}));
